import { render, staticRenderFns } from "./NavAdmin.vue?vue&type=template&id=460934f8&scoped=true&"
import script from "./NavAdmin.vue?vue&type=script&lang=js&"
export * from "./NavAdmin.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/users-nav.scss?vue&type=style&index=0&id=460934f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460934f8",
  null
  
)

export default component.exports